import { jsx } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import { CheckboxGroupContext } from './context.es.js';

/**
 * Checkbox Group Provider.
 */ const CheckboxGroupProvider = (props)=>{
    const { children, ...rest } = props;
    // Is checked helper.
    const isChecked = useCallback((value)=>rest.value?.includes(value), [
        rest.value
    ]);
    // Derived onChange handler helper.
    const deriveOnChange = useCallback((ev, value)=>{
        const currentValue = rest.value;
        let updatedValues = [
            value
        ];
        if (currentValue) {
            if (ev.target.checked) {
                updatedValues = [
                    ...currentValue,
                    value
                ]; // add item
            } else {
                updatedValues = currentValue.filter((i)=>i !== value); // remove item
            }
        }
        rest.onChange?.(updatedValues);
    }, [
        rest
    ]);
    // Memoized provider value.
    const value = useMemo(()=>({
            ...rest,
            isChecked,
            deriveOnChange
        }), [
        rest,
        isChecked,
        deriveOnChange
    ]);
    return jsx(CheckboxGroupContext.Provider, {
        value: value,
        children: children
    });
};

export { CheckboxGroupProvider };
//# sourceMappingURL=provider.es.js.map
